import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import pkg from '@/package.json'

export default function(ctx, inject, envName) {
  const _envName = ctx ? process.env.envName : envName
  const enabled = ctx ? process?.env?.NODE_ENV === 'production' : true

  const featureFlagSentryData =
    ctx?.store?.state['feature-flag']?.featureFlagSentryData

  Sentry.init({
    Vue,
    dsn: process.env.sentryDsn,
    enabled,
    environment: _envName,
    release: `${process.env.sentryProject}@${pkg.version}`,
    beforeSend(event) {
      if (!event.unifiedApp) event.unifiedApp = { accessToken: null }
      if (featureFlagSentryData?.user && event.unifiedApp)
        event.unifiedApp.accessToken = window.unifiedApp?.accessToken
      if (event.user) {
        if (!featureFlagSentryData || !featureFlagSentryData?.user)
          delete event.user
      }
      if (event.profile) {
        if (!featureFlagSentryData || !featureFlagSentryData?.user)
          delete event.profile
      }
      return event
    }
  })
  Vue.prototype.$sentry = Sentry
  if (ctx && inject) {
    ctx.$sentry = Sentry
    inject('sentry', Sentry)
  }
}
